










import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import resize from 'vue-resize-directive';
import * as Components from '@/agiles/components';

@Component({
  directives: {
    resize,
  },
})
export default class EditPanel extends Vue {
  @Prop() scroll0: string;
  @Prop() scroll1: string;
}
